import React, { useEffect, useRef } from "react";
import "./TextAnimation.scss";

const ParagraphAnimation = ({ children, className }) => {
  const ref = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      const element = ref.current;
      if (element) {
        const rect = element.getBoundingClientRect();
        if (rect.top < window.innerHeight * 0.8 && rect.bottom > 0) {
          element.classList.add("animated");
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll(); // Trigger on initial render

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div ref={ref} className={className || "paragraph-animation"}>
      {children}
    </div>
  );
};

export default ParagraphAnimation;
